import { useEffect, useState } from "react";
import { Settings2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const REPARTI = [["22", "IVA 22%"], ["10", "IVA 10%"], ["5", "IVA 5%"], ["4", "IVA 4%"], ["N4", "Esente"], ["N2.2", "Forfettario"]];
const KEYS = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "0", "00", "C"];

export const Display = ({ buffer, qty, totale, ultima }) => (
  <div className="rounded-xl border-4 border-slate-700 bg-[#0B1F2E] p-4 font-mono text-[#7CF3FF] shadow-inner" data-testid="pos-display">
    <div className="flex justify-between text-xs uppercase tracking-widest text-[#7CF3FF]/70"><span>{ultima || "Pronto"}</span><span>{qty > 1 ? `x ${qty}` : ""}</span></div>
    <div className="text-right text-5xl font-bold tabular-nums sm:text-6xl" data-testid="pos-display-amount">{(Number(buffer || 0) / 100).toLocaleString("it-IT", { minimumFractionDigits: 2 })}</div>
    <div className="mt-2 flex justify-between border-t border-[#7CF3FF]/30 pt-2 text-lg"><span>TOTALE</span><span data-testid="pos-total" className="text-2xl font-bold tabular-nums">{totale.toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span></div>
  </div>
);

export const Keypad = ({ onKey, onTimes, onReparto }) => (
  <div className="grid grid-cols-4 gap-2" data-testid="pos-keypad">
    <div className="col-span-3 grid grid-cols-3 gap-2">
      {KEYS.map((k) => (
        <button key={k} type="button" data-testid={`pos-key-${k}`} onClick={() => onKey(k)}
          className={`h-14 rounded-lg text-2xl font-bold shadow-sm transition-transform active:scale-95 ${k === "C" ? "bg-rose-600 text-white hover:bg-rose-700" : "bg-white text-slate-900 hover:bg-sky-50"}`}>{k}</button>
      ))}
    </div>
    <div className="grid gap-2">
      <button type="button" data-testid="pos-key-times" onClick={onTimes} className="h-14 rounded-lg bg-slate-700 text-xl font-bold text-white hover:bg-slate-800 active:scale-95">X</button>
      {REPARTI.slice(0, 3).map(([k, l]) => (
        <button key={k} type="button" data-testid={`pos-dept-${k}`} onClick={() => onReparto(k)} className="h-14 rounded-lg bg-blue-700 text-sm font-bold text-white hover:bg-blue-800 active:scale-95">{l}</button>
      ))}
    </div>
    <div className="col-span-4 grid grid-cols-3 gap-2">
      {REPARTI.slice(3).map(([k, l]) => (
        <button key={k} type="button" data-testid={`pos-dept-${k}`} onClick={() => onReparto(k)} className="h-12 rounded-lg bg-blue-700 text-sm font-bold text-white hover:bg-blue-800 active:scale-95">{l}</button>
      ))}
    </div>
  </div>
);

const ConfigDialog = ({ open, setOpen, tasti, products, onSave }) => {
  const [sel, setSel] = useState([]);
  useEffect(() => { if (open) setSel(tasti.map((t) => t?.id || "")); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="quick-keys-dialog">
        <DialogHeader><DialogTitle>Configura i 10 tasti rapidi</DialogTitle></DialogHeader>
        <div className="grid gap-2 sm:grid-cols-2">
          {Array.from({ length: 10 }, (_, i) => (
            <Select key={i} value={sel[i] || "none"} onValueChange={(v) => setSel(sel.map((x, j) => (j === i ? (v === "none" ? "" : v) : x)))}>
              <SelectTrigger data-testid={`quick-key-select-${i}`}><SelectValue placeholder={`Tasto ${i + 1}`} /></SelectTrigger>
              <SelectContent><SelectItem value="none">Tasto {i + 1}: vuoto</SelectItem>{products.map((p) => <SelectItem key={p.id} value={p.id}>{i + 1}. {p.descrizione}</SelectItem>)}</SelectContent>
            </Select>
          ))}
        </div>
        <DialogFooter><Button data-testid="quick-keys-save" onClick={() => { onSave(sel); setOpen(false); }}>Salva tasti</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const QuickKeys = ({ tasti, products, write, onPick, onSave }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between"><span className="text-xs font-semibold uppercase tracking-wide text-slate-700">Prodotti più venduti</span>
        {write && <Button size="sm" variant="ghost" data-testid="quick-keys-config-button" onClick={() => setOpen(true)}><Settings2 className="mr-1 h-4 w-4" />Configura</Button>}</div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-5 lg:grid-cols-2">
        {tasti.map((p, i) => (
          <button key={i} type="button" disabled={!p} data-testid={`quick-key-${i}`} onClick={() => p && onPick(p)}
            className="flex h-16 flex-col items-center justify-center rounded-lg border border-yellow-400 bg-yellow-300 px-2 text-center text-sm font-semibold text-slate-900 shadow-sm hover:bg-yellow-200 active:scale-95 disabled:border-dashed disabled:opacity-80 disabled:text-slate-600">
            <span className="line-clamp-2 leading-tight">{p ? p.descrizione : `Tasto ${i + 1}`}</span>
          </button>
        ))}
      </div>
      <ConfigDialog open={open} setOpen={setOpen} tasti={tasti} products={products} onSave={onSave} />
    </div>
  );
};
